import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { setError, setLoading, setStatistic, Statistic } from 'store/models/campaignStatistic';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const fetchStatistic = (campaignId: string): AppThunkAction => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return fetcher
            .get<unknown, Statistic>(`/api/v1/campaigns/${campaignId}/statistic`)
            .then((statistic) => {
                dispatch(setStatistic(statistic));
            })
            .catch(() => {
                dispatch(setError(true));
                dispatch(addMagritteNotification(MagritteNotificationName.CampaignStatisticCardSomethingWentWrong));
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};
